module.exports = __webpack_public_path__ + "img/logo.26d9a6b2.png";